import { defineComponent, ref, onMounted, computed } from 'vue';

var script = defineComponent({
    name: 'TransitionFadeOutIn',
    props: {
        initialFadeIn: Boolean,
        quick: Boolean,
    },
    setup(props) {
        const mounted = ref(false);
        onMounted(() => {
            mounted.value = true;
        });
        const showSlot = computed(() => props.initialFadeIn ? mounted.value : true);
        const transitionName = computed(() => {
            if (props.quick)
                return 'fade-out-in-quick';
            return 'fade-out-in';
        });
        const classNames = computed(() => {
            const names = [];
            if (props.initialFadeIn)
                names.push('TransitionFadeOutIn--initial-fade-in');
            return names;
        });
        return {
            classNames,
            showSlot,
            transitionName,
        };
    },
});

export { script as default };
